import {
    GET_REASON_TYPE,
    SET_REASON_TYPE
} from "./ReasonTypeType"

const getReasonType = () => ({
    type: GET_REASON_TYPE
});

const setReasonType = (reasonTypeDropDown: any) => ({
    type: SET_REASON_TYPE,
    reasonTypeDropDown: reasonTypeDropDown
});

export {
    getReasonType,
    setReasonType
}
